"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrl = exports.getContractAddress = void 0;
const getContractAddress = (address) => address;
exports.getContractAddress = getContractAddress;
const getUrl = (url) => url;
exports.getUrl = getUrl;
//# sourceMappingURL=utils.js.map